import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { useEditorContext } from "../EditorContext";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { useEffect, useRef } from "react";

export default function ContentEditablePlugin() {
	const { showTopToolbar, placeholder, focus } = useEditorContext();
	const editorRef = useRef(null);

	useEffect(() => {
		if (focus && editorRef.current) {
			editorRef.current.focus();
		}
	}, [focus, editorRef.current]);

	return <RichTextPlugin
		contentEditable={
			<ContentEditable
				ref={editorRef}
				onKeyDown={(e) => {
					e.stopPropagation();
					if (e.key === "Enter") {
						e.preventDefault();
					}
				}}
				className={`pl-2 ${!showTopToolbar && 'pt-2'} outline-none grow`}
			/>
		}
		placeholder={placeholder ? <div className={`absolute ${showTopToolbar ? 'top-6' : 'top-2'} left-2 text-gray-400 pointer-events-none select-none`}>{placeholder}</div> : null}
		ErrorBoundary={LexicalErrorBoundary}
	/>

}